import React from 'react';


interface IErrorContainerState {
  hasError: boolean;
  error: Error | null;
}

export interface IErrorContainerProps {
  component: React.FC<{ errorMessage: ErrorMessage }>;
  logErrorOnServer?(errorMessage: ErrorMessage): void;
}

export interface ErrorMessage {
  error: Error | null;
}



export class ErrorContainer extends React.Component<IErrorContainerProps, IErrorContainerState> {
  public static displayName: string = 'ErrorContainer';

  constructor(props: Readonly<IErrorContainerProps>) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): IErrorContainerState {
    return ({ error, hasError: true });
  }

  public render(): JSX.Element | null {
    const { hasError, error } = this.state;
    const { children, component: Component } = this.props;

    if (hasError) {
      if (Component) {
        return <Component errorMessage={{ error }} />;
      }

      return <h1>Es ist ein unerwarteter Fehler aufgetreten.</h1>;
    }

    return (
      <React.Fragment>
        {children}
      </React.Fragment>
    );
  }



}
